// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__a_gAX","meta":"styles_meta__Z_UdK","metaItem":"styles_metaItem__E5wNO","dot":"styles_dot__yFqOA","description":"styles_description__zXwj8"};